<template>
    <div>
        <div class="section-confirm">
            <div class="container text-center">
                <div class="logo-container">
                    <img class="n-logo" width="130" height="40" src="img/logotipo_mod2.png" alt="U4CROWD" />
                </div>
                <div class="row justify-content-md-center">
                    <div class="col-md-12 col-lg-12 ml-auto mr-auto">
                        <h3 class="title">Ingresa una contraseña nueva</h3>
                        <span v-if="loading"><square-grid background="#FFFFFF"></square-grid> Loading...</span>
                        <alert v-if="success && success.message" type="success">
                            {{success.message}}
                        </alert>
                        <alert v-if="error" type="danger">
                            {{error.message}}
                        </alert>
                    </div>
                    <div class="col-md-6 ml-auto mr-auto">
                    <div class="row">
                        <card class="p-5">
                            <el-form ref="formData" :model="formData" :rules="rules">
                                <el-form-item prop="password">
                                    <el-input 
                                    placeholder="Nueva contraseña" 
                                    v-model="formData.password" 
                                    show-password
                                    prefix-icon="now-ui-icons objects_key-25"
                                    >
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="rep_password">
                                    <el-input 
                                    placeholder="Confirmar contraseña" 
                                    v-model="formData.rep_password" 
                                    show-password
                                    prefix-icon="now-ui-icons objects_key-25"
                                    >
                                    </el-input>
                                </el-form-item>
                                <div class="card-footer text-center">
                                    <el-button class="btn-primary btn btn-lg" size="large" round type="primary" @click="onSubmit()">{{$t('restore.button')}}</el-button>
                                </div>
                            </el-form>
                        </card>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="section text-center" v-if="success">
            <div class="container-fluid text-center">
                
            </div>
        </div>
    </div>
</template>
<script>
import {RotateSquare2, SquareGrid} from 'vue-loading-spinner'
import { Card, Alert } from '@/components';
import { Input, Button, Form, FormItem, Link } from 'element-ui';
import Auth from '@/providers/Auth'
const AuthProvider = new Auth()

export default {
  name: 'restore-password',
  components: {
    RotateSquare2,
    SquareGrid,
    Card,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    Alert
  },
  mounted() {
      this.validToken(this.$route.query._tk);
  },
  data() {
    return {
        formData: {
            password: null,
            rep_password: null
        },
        loading: false,
        error: null,
        success: null,
        rules: {
            password: [{ required: true, message: 'Porfavor ingresa una contraseña', trigger: 'blur' }],
            rep_password: [{ required: true, message: 'Porfavor confirma la nueva contraseña', trigger: 'change' }]
        }
    }
  },
  methods: {
      validToken(token) {
        this.loading = true
        let data = {
            _tk: token
        }
        AuthProvider.verifyToken(data).then((resp)=> {
            this.error = null
            this.loading = false
            this.success = {}
        }).catch((err)=>{
            this.loading = false
            if(err.status && (err.status === 403)) {
                this.error = {
                    message: "El enlace ha expirado, solicita uno nuevo."
                }
            }else {
                this.error = {
                    message: "Error de comunicación"
                }
            }
        })
      },
      onSubmit () {
        this.$refs['formData'].validate((valid) => {
            if (valid) {
                this.formData.token = this.$route.query._tk
                this.loading = true
                AuthProvider.restore(this.formData).then((resp)=> {
                    this.error = null
                    this.loading = false
                    this.success = {
                        message: "La contraseña ha sido cambiada exitosamente, serás redireccionado(a)."
                    }
                    setTimeout(() => {
                        this.$router.push('/') 
                    }, 2000);
                }).catch((err)=>{
                    this.loading = false
                })
            } else {
                return false
            }
        })
    }
  }
};
</script>
<style>
</style>
